import axios from "axios";

export default function validateFormExternalSubmit(e) {
    e.preventDefault();

    let formObject = e.target;
    let method = formObject.getAttribute('method');

    if (method === 'POST') {
        let formData = new FormData(formObject);
        let formProps = Object.fromEntries(formData);
        let action = formObject.getAttribute('action');

        formProps.just_validating = 1;

        axios.post(action, formProps)
            .then(res => {
                formObject.submit();
                return true;
            })
            .catch(error => {
                let element = document.getElementById("pulse_validation_error");

                if (!element) {
                    element = document.createElement("div");
                    element.className = 'alert alert-danger';
                    element.id = 'pulse_validation_error';
                    formObject.insertBefore(element, formObject.firstChild);
                }

                element.textContent = error.response.data.message;

                window.scrollTo({ top: 0, behavior: "smooth" }); //One of these will work on all browsers
                window.scrollTo(0, 0);
                element.scrollIntoView();

                return false;
            });
    } else {
        formObject.submit();
        return true;
    }
}


// WEBPACK FOOTER //
// ./app/Modules/FormBuilder/resources/assets/js/validateFormExternalSubmit.js